/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Copyright by INSIDE M2M GmbH and the authors 2004 - 2018
 *
 *************************************************************
 ********************* CONFIDENTIAL **************************
 *************************************************************
 *
 */

/**
 * Utility functions for event handling.
 */
export namespace EventUtils {
    /**
     * Simulate a KeyboardEvent with the given key code.
     */
    export function keyPress(key: number, keyEventType: 'keyup' | 'keydown' | 'keypress' = 'keydown') {
        const e = new (window as any).KeyboardEvent(keyEventType, {
            bubbles: true,
            cancelable: true,
        });

        delete e.keyCode;
        Object.defineProperty(e, 'keyCode', { value: key });
        document.dispatchEvent(e);
    }

    export function getNumber(event: KeyboardEvent) {
        return Number(String.fromCharCode(getKeyCode(event)));
    }

    export function isNumber(o: any) {
        return o === '' || !isNaN(o - 0);
    }

    /**
     * Checks whether the given event was triggered by a number key.
     */
    export function isNumberKey(event: KeyboardEvent) {
        let keyCode = event.keyCode || event.which;
        if (keyCode >= 96 && keyCode <= 105) {
            // Numpad keys
            keyCode -= 48;
        }
        return isNumber(String.fromCharCode(keyCode));
    }

    /**
     * Checks whether the given event was triggered by backspace, arrow or a number key.
     */
    export function isNumberBackspaceArrowKey(event: KeyboardEvent) {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 8 || (keyCode >= 37 && keyCode <= 40)) {
            // backspace and arrow keys
            return String.fromCharCode(keyCode);
        } else {
            return isNumberKey(event);
        }
    }

    export function isMetaKey(event: KeyboardEvent) {
        const isCtrlKey = getKeyCode(event) === 17;
        const isBackspaceKey = getKeyCode(event) === 8;
        const isEnterKey = getKeyCode(event) === 13;
        // TODO: Add Esc, Shift and Alt keys
        return isCtrlKey || isBackspaceKey || isEnterKey;
    }

    export function getKeyCode(event: KeyboardEvent) {
        // Safari does not support the keyCode property and sets the which property instead.
        return event.keyCode || event.which;
    }
}
